// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class Session extends TrackingModel {
	public SessionId: number = 0;
	public SessionUID: string = "";
	public UserUID: string = "";
	public PersonId?: number;
	public RobotId?: number;
}